import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { loc } from "@/lib/localize";
import { PageHero } from "@/components/common/PageHero";
import { FileText, ArrowRight } from "lucide-react";

export default function Legal() {
  const { L, isAr } = useLang();
  const P = L.pages.legal;
  usePageSeo("legal");
  const { data: pages = [] } = useQuery({ queryKey: ["legal"], queryFn: async () => (await api.get("/legal")).data });

  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: P.overline }]}
      />
      <section className="py-16 lg:py-24">
        <div className="container-tight grid gap-4 md:grid-cols-2">
          {pages.map((p) => (
            <Link key={p.slug} to={`/legal/${p.slug}`} className="group flex items-center justify-between rounded-xl border border-hair bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md" data-testid={`legal-link-${p.slug}`}>
              <div className="flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-gold"><FileText className="h-5 w-5" strokeWidth={1.5} /></span>
                <div>
                  <p className="font-heading font-semibold text-ink">{loc(p, "title", isAr)}</p>
                  <p className="text-xs text-subtle">{P.updated} {new Date(p.updated_at).toLocaleDateString(isAr ? "ar" : "en-GB")}</p>
                </div>
              </div>
              <ArrowRight className="h-5 w-5 text-subtle transition-transform group-hover:translate-x-1 group-hover:text-finblue rtl:rotate-180" />
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
